import React__default from 'react';
import clsx from 'clsx';
import { useFormContext, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import FieldThesaurus from '../../../Fields/FieldThesaurus/index.js';
import { TreeFieldMode } from '../../../Fields/TreeField/types.js';
import { useFormFieldThesaurusContainer } from '../../../providers/formFields/hooks.js';

var FieldThesaurusContainer = function FieldThesaurusContainer(_a) {
    var formField = _a.formField, sx = _a.sx, className = _a.className, _b = _a.testId, testId = _b === void 0 ? "FieldThesaurusContainer" : _b, invertColors = _a.invertColors, modes = _a.modes, multiple = _a.multiple, KIcon = _a.KIcon;
    var _c = useFormFieldThesaurusContainer({ formField: formField }), loadOptionsForThesaurusId = _c.loadOptionsForThesaurusId, options = _c.options, autocompleteSearch = _c.autocompleteSearch, autocompleteOptions = _c.autocompleteOptions;
    var control = useFormContext().control;
    var t = useTranslation("refront-components").t;
    return (React__default.createElement(Controller, { name: formField.id, defaultValue: formField.value, control: control, rules: {
            required: formField.required &&
                t("components.fields.validation.required", {
                    field: formField.title
                }).toString()
        }, render: function (_a) {
            var _b = _a.field, onChange = _b.onChange, onBlur = _b.onBlur, value = _b.value, _c = _a.fieldState, invalid = _c.invalid, error = _c.error;
            return (React__default.createElement(FieldThesaurus, { title: formField.required
                    ? t("components.fields.required", {
                        field: formField.title
                    }).toString()
                    : formField.title, description: formField.description, forceSelection: formField.forceSelection || false, onChange: onChange, onBlur: onBlur, onAutocomplete: function (query) { return autocompleteSearch(query); }, defaultMode: formField.treeViewByDefault
                    ? TreeFieldMode.TREE_VIEW
                    : TreeFieldMode.TREE_AUTOCOMPLETE, multiple: multiple, modes: modes, values: value, options: options, autocompleteOptions: autocompleteOptions, getOptions: function (thesaurusId) { return loadOptionsForThesaurusId(thesaurusId); }, sx: sx, className: clsx("FieldThesaurusContainer", className), testId: testId, error: invalid, helperText: error === null || error === void 0 ? void 0 : error.message, invertColors: invertColors, KIcon: KIcon }));
        } }));
};

export { FieldThesaurusContainer as default };
//# sourceMappingURL=index.js.map
